// Authentic PEEPING wordmark rebuilt as an SVG React component:
// thin geometric strokes with the distinctive SEGMENTED "E" (three bars, no spine).
// White wordmark + violet->magenta "COME CLOSER" tagline, per the approved brand.

const STROKE = 6;

// Each glyph drawn on a 40 (w) x 80 (h) grid; glyphs advance by 52px.
const GLYPHS = {
  P: [
    [0, 0, 0, 80],
    [0, 0, 32, 0],
    [32, 0, 32, 40],
    [0, 40, 32, 40],
  ],
  E: [
    // segmented E — three detached horizontal bars
    [0, 0, 34, 0],
    [0, 40, 34, 40],
    [0, 80, 34, 80],
  ],
  I: [[17, 0, 17, 80]],
  N: [
    [0, 0, 0, 80],
    [34, 0, 34, 80],
    [0, 0, 34, 80],
  ],
  G: [
    [2, 0, 34, 0],
    [0, 2, 0, 78],
    [2, 80, 34, 80],
    [34, 44, 34, 80],
    [18, 44, 34, 44],
  ],
};

const WORD = ["P", "E", "E", "P", "I", "N", "G"];

export function PeepingLogo({ className = "w-48", showTagline = true, tagline = "COME CLOSER", taglineClassName = "mt-2 text-[0.6rem] sm:text-xs tagline-track" }) {
  const width = WORD.length * 52 + 10;
  return (
    <div className={`flex flex-col items-center ${className}`} data-testid="peeping-logo">
      <svg viewBox={`-3 -4 ${width} 88`} className="w-full" role="img" aria-label="PEEPING">
        {WORD.map((ch, i) =>
          GLYPHS[ch].map(([x1, y1, x2, y2], j) => (
            <line
              key={`${i}-${j}`}
              x1={x1 + i * 52}
              y1={y1}
              x2={x2 + i * 52}
              y2={y2}
              stroke="#ffffff"
              strokeWidth={STROKE}
              strokeLinecap="square"
            />
          ))
        )}
      </svg>
      {showTagline && (
        <span data-testid="peeping-logo-tagline" className={`${taglineClassName} max-w-full whitespace-nowrap font-medium text-brand-gradient uppercase`}>
          {tagline}
        </span>
      )}
    </div>
  );
}
